export default __webpack_public_path__ + "static/media/esia_banner.604eee4b.jpg";